import { Component, HostListener, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { fromEvent, Subscription } from 'rxjs';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  title: string;
  content: string | SafeHtml;
  open = false;

  subscriptionData: Subscription;
  subscriptionClickOut: Subscription;

  @ViewChild('my_modal', {static: false}) myModal;


  constructor(
    private modalService: ModalService,
    private sanitizer: DomSanitizer,
    private zone: NgZone
  ) { }

  ngOnInit() {
    this.subscribeData();
  }

  resetData(){
    this.title = null;
    this.content = null;
    this.open = false;
  }

  subscribeData(){
    this.subscriptionData = this.modalService.sendModalData.subscribe((data) => {
      this.title = data.title;
      this.content = this.sanitizer.bypassSecurityTrustHtml(data.content);
      this.open = true;
      event.stopPropagation();
      this.subscribeClickOut();
    })
  }

  subscribeClickOut(){
    this.subscriptionClickOut = fromEvent(document, 'click').subscribe((ev) => {
      // console.log("click");
      if(!this.myModal.nativeElement.contains(ev.target)) {
        this.zone.run(() => {
          this.closeModal()
        })
      }
    })
  }

  unsubscribeClickOut(){
    if(this.subscriptionClickOut){
      this.subscriptionClickOut.unsubscribe();
      this.subscriptionClickOut = null;
    }
  }

  closeModal(){
    this.resetData();
    this.unsubscribeClickOut();
  }

}
